import React, {useEffect} from 'react'
import './portfolio.css'
import IMG1 from '../../assets/portfolio1.png';
import IMG2 from '../../assets/portfolio2.png';
import IMG3 from '../../assets/panda.png';
import IMG4 from '../../assets/portfolio4.jpg';
import IMG5 from '../../assets/portfolio5.jpg';
import IMG6 from '../../assets/portfolio6.png';
import AOS from 'aos'
import 'aos/dist/aos.css'
const Portfolio = () => {
 
  useEffect(() => {
    AOS.init()
  })
  const data = [
    {
      id: 1,
      title: "Shadow Swap DEX platform",
      image: IMG1,
      github: "https://github.com/SVerseLab/shadowswap-frontend",
      demo: "https://shadowswap.xyz"
    },
    {
      id: 2,
      title: "ProximaForte",
      image: IMG5,
      github: "#portfolio",
      demo: "https://www.proximaforte.com/"
    },
    {
      id: 3,
      title: "SwiftTek Bill Payment",
      image: IMG3,
      github: "#portfolio",
      demo: "https://swifttek.ng"
    },
    {
      id: 4,
      title: "Bamiraa",
      image: IMG4,
      github: "#portfolio",
      demo: "https://bamiraa.com/"
    },

    {
      id: 5,
      title: "Blackzeuss ",
      image: IMG2,
      github: "#",
      demo: "https://blackzeuss.com/"
    },
    {
      id: 6,
      title: "Betaship eCommerce",
      image: IMG6,
      github: "#",
      demo: "https://betaship.com.ng"
    }
  ]
  return (
    <section id='portfolio'>
      <h5 data-aos="fade-up">My recent work</h5>
      <h2 data-aos="fade-up">Portfolios</h2>

      <div className="container portfolio__container" data-aos="fade-up">
        {
          data.map(({id, title, image, github, demo}) => {
            return (
              <article key={id} className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={image} alt="" />
          </div>
          <h3>{title}</h3>
          <div className="portfolio__item-cta">
          <a href={github} className="btn" target='__blank'>Github</a>
          <a href={demo} className="btn btn-primary" target='__blank'>View Website</a>

          </div>
         
        </article>

            )
          })
        }
        
      </div>
    </section >
  )
}

export default Portfolio